import { combineReducers } from 'redux';
import tickets, { tickets_url } from './tickets';
import { newticket } from './addTicket'
import { modelList } from './models.js'

import { techlist } from "./tech";
import auth, * as fromAuth from './auth.js'
import { producerList } from './producer'
import { ticket } from './ticketItem'
import filters from './filters'
import { listRepair } from "./repair";
import { listStatus } from "./status";
import { history } from "./history";
import { comments } from "./comments";
import { region } from "./region";
import { repairModels } from "./repairModels"
import { departament } from './departament'
import { modalAction, commentModal } from "./modal";
import { routerReducer } from 'react-router-redux'
import { addComment } from './addComment'
import { model_list_filter, model_list_newticket } from './modelTechnics'
import { report } from './report'

export default combineReducers({
  tickets, tickets_url,
  departament, region, repairModels,
  modalAction, commentModal,
  ticket, history, comments,
  modelList, producerList,
  listRepair, listStatus,
  techlist, newticket,
  model_list_filter, model_list_newticket,
  filters, addComment,
  report,
  auth: auth,
  router: routerReducer,
});

export const isAuthenticated = state => fromAuth.isAuthenticated(state.auth)
export const accessToken = state => fromAuth.accessToken(state.auth)
export const showToken = () => fromAuth.showToken()
export const isAccessTokenExpired = state => fromAuth.isAccessTokenExpired(state.auth)
export const refreshToken = state => fromAuth.refreshToken(state.auth)
export const isRefreshTokenExpired = state => fromAuth.isRefreshTokenExpired(state.auth)
export const authErrors = state => fromAuth.errors(state.auth)

export function withAuth(headers = {}) {
  return (state) => ({
    ...headers,
    'Authorization': `Bearer ${accessToken(state)}`
  })
}


// WEBPACK FOOTER //
// ./src/reducers/index.js